import { render, staticRenderFns } from "./input-tags.vue?vue&type=template&id=62e7c410&"
import script from "./input-tags.vue?vue&type=script&lang=ts&"
export * from "./input-tags.vue?vue&type=script&lang=ts&"
import style0 from "./input-tags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports